import { useRef } from 'react';
import { ChevronLeft, ChevronRight, List } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useSetMobileNavHeight } from '@/hooks/useSetMobileNavHeight';

interface PlayerMobileNavProps {
  hasPrevious: boolean;
  hasNext: boolean;
  onPrevious: () => void;
  onNext: () => void;
  onOpenContents: () => void;
}

export function PlayerMobileNav({
  hasPrevious,
  hasNext,
  onPrevious,
  onNext,
  onOpenContents,
}: PlayerMobileNavProps) {
  const navRef = useRef<HTMLDivElement>(null);
  useSetMobileNavHeight(navRef);

  return (
    <div
      ref={navRef}
      className="md:hidden fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 z-50"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-3 gap-1 py-2">
          <button
            onClick={onOpenContents}
            className="flex flex-col items-center justify-center space-y-1 py-1 min-h-[44px] text-gray-600 dark:text-gray-300"
            aria-label="Open table of contents"
          >
            <List className="h-5 w-5" />
            <span className="text-xs">Contents</span>
          </button>
          <button
            onClick={onPrevious}
            disabled={!hasPrevious}
            className={cn(
              'flex flex-col items-center justify-center space-y-1 py-1 min-h-[44px]',
              !hasPrevious
                ? 'opacity-30 cursor-not-allowed'
                : 'text-gray-600 dark:text-gray-300'
            )}
            aria-label="Previous lesson"
          >
            <ChevronLeft className="h-5 w-5" />
            <span className="text-xs">Previous</span>
          </button>
          <button
            onClick={onNext}
            disabled={!hasNext}
            className={cn(
              'flex flex-col items-center justify-center space-y-1 py-1 min-h-[44px]',
              !hasNext
                ? 'opacity-30 cursor-not-allowed'
                : 'text-gray-600 dark:text-gray-300'
            )}
            aria-label="Next lesson"
          >
            <ChevronRight className="h-5 w-5" />
            <span className="text-xs">Next</span>
          </button>
        </div>
      </div>
    </div>
  );
}
